import { render, staticRenderFns } from "./BookingHistoryModal.vue?vue&type=template&id=e3c18e8e"
import script from "./BookingHistoryModal.vue?vue&type=script&lang=js"
export * from "./BookingHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports